import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjsMixin from '../../mixins/dayjs';
import viewport from '../../mixins/viewport';

dayjs.extend(customParseFormat);

export default {
  name: 'Date',
  mixins: [
    viewport,
    dayjsMixin,
  ],
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'change',
  },
  events: ['change'],
  props: {
    value: {
      type: [String, Object],
      default: null,
    },
    mask: {
      type: String,
      default: '##.##.####',
    },
    maskValidate: {
      type: String,
      default: 'DD.MM.YYYY',
    },
    placeholder: {
      type: String,
      default: '00.00.0000',
    },
    persistentPlaceholder: {
      type: Boolean,
      default: true,
    },
    messages: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      date: null,
      datePicker: null,
      dateValue: '',
      isSameDate: false,
      menu: false,
      focus: null,
      view: 'date',
      menuStyle: {
        width: '300px',
        border: 'none',
        boxShadow: '0 6px 14px -6px rgba(24, 39, 75, 0.12), 0 10px 32px -4px rgba(24, 39, 75, 0.1)',
      },
      msg: this.messages,
    };
  },
  watch: {
    value: {
      handler(value) {
        const date = dayjs(value);

        if (date.isValid()) {
          this.date = date;
          this.dateValue = this.date.format(this.maskValidate);
          this.datePicker = this.date;
        } else {
          this.dateValue = '';
          this.datePicker = null;
        }
      },
      immediate: true,
    },
    dateValue(value) {
      if (this.isValid(value)) {
        if (value !== dayjs(this.date).format(this.maskValidate)) {
          this.date = dayjs(value, this.maskValidate);
          this.datePicker = this.date;
        }
      }
    },
    datePicker(value) {
      if (!value) return;

      this.date = value;
      this.dateValue = this.date.format(this.maskValidate);
    },
    date(value, oldValue) {
      if (!value) return;

      this.isSameDate =
        value.isSame(oldValue, 'year') &&
        value.isSame(oldValue, 'month') &&
        value.isSame(oldValue, 'day');

      this.emitEvent('change', value);
    },
  },
  methods: {
    clickDatePicker() {
      this.menu = false;
    },
    selectedDatePicker(value) {
      this.changeDatePicker(value);
    },
    changeDatePicker(value) {
      this.date = value;
      this.focus = true;
    },
    isValid(date) {
      return dayjs(date, this.maskValidate, true).isValid();
    },
    dateInputHandler(value) {
      this.dateValue = value;
      this.$emit('input', value);
    },
    changeView(view, value) {
      this.view = value ? view : 'date';
    },
    onBlur() {
      if (!this.isValid(this.dateValue)) {
        this.date = null;
        this.dateValue = '';
        this.datePicker = null;
        this.$emit('change', null);
      }
    },
    toggleMenu() {
      this.menu = !this.menu;
      if (this.menu) this.focus = false;
    },
    closeMenuMobile() {
      this.menu = false;
      this.focus = true;
    },
    closeMenu() {
      if (!this.isMobile) {
        this.menu = false;
      }
      this.focus = true;
    },
    emitEvent(name, value, checkDate = true, props = this.value) {
      if (typeof props === 'string') {
        this.$emit(name, value.toISOString());
      } else {
        if (checkDate) {
          if (!this.isSameDate) this.$emit(name, value);
        } else {
          this.$emit(name, value);
        }
      }
    },
  },
};
